import { CellContext, createColumnHelper } from "@tanstack/react-table";
import React, { useState } from "react";
import { Col, Offcanvas } from "react-bootstrap";
import IConfirmacionMantenedor from "../../../../entities/helper/IConfirmacionMantenedor";
import IPlan from "../../../../entities/IPlan";
import ILogMantenedor from "../../../../entities/ILogMantenedor";
import { shortDate } from "../../../../helpers/dateHelper";
import { ITipo_Campo } from "../../../../helpers/IFormHelper";
import { getAPI, postAPI } from "../../../../helpers/httpHelper";
import { usePromiseEffect } from "../../../../helpers/promiseEffect";
import { cognitoUserInfo, cognitoUserToken } from "../../../../helpers/userHelper";
import {
  API_ADMIN_AREA_RESPONSABLE,
  API_ADMIN_MANTENEDOR_PROGRAMAS_ANUALES,
  API_ADMIN_TIPO_PROCESO,
  ROW_COUNT,
  URL_SUPPORT,
} from "../../../../helpers/variableHelper";
import AdminLista from "../../AdminLista";
import RenderForm from "../../RenderForm";
import { IAreaResponsable } from "../../../../entities/IAreaResponsable";
import { ITipoProceso } from "../../../../entities/ITipoProceso";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import moment from "moment";
import ICurrentUser from "../../../../entities/helper/ICurrentUser";
import Select from "react-select";
import { IComboboxOption } from "../../../../entities/helper/IComboboxOption";
import CustomToast from "../../../../cross/CustomToast";
import { cParamsActiveOrderTitle } from "../../../../helpers/paramsHelper";
import { updateFilter, updateSelectedField } from "../UtilsMantenedor";
import { downloadFile } from "../../../../helpers/fileHelper";
import ProveedorService from "../../../../services/ProveedorService";
import RenderTitle from "../../../../controls/RenderTitle";
import RenderValue from "../../../../controls/RenderValue";
import RenderLink from "../../../../controls/RenderLink";

const MySwal = withReactContent(Swal);
interface IMantenedorProgramasAnualesProps {
  items?: Array<any>;
  cbAreaResponsable?: Array<IAreaResponsable>;
  cbTipoRpoceso?: Array<ITipoProceso>;
  itemsArrCambiosForm?: Array<IConfirmacionMantenedor>;
  is_test?: boolean;
  loading?: boolean;
}
export default function MantenedorProgramasAnuales({
  loading,
  is_test,
  items,
  cbAreaResponsable,
  cbTipoRpoceso,
  itemsArrCambiosForm,
}: IMantenedorProgramasAnualesProps) {
  let paramsActive = cParamsActiveOrderTitle;
  const userInfo = cognitoUserToken();
  const [token, setToken] = useState("");
  const [currentUser, setCurrentUser] = useState<ICurrentUser>();
  const [comboARMP, setComboARMP] = useState<Array<IAreaResponsable>>(cbAreaResponsable || []);
  const [comboTPMP, setComboTPMP] = useState<Array<ITipoProceso>>(cbTipoRpoceso || []);

  const [isEditColumMP, setIsEditColumMP] = useState<boolean>(false);
  const [editColumnInfoMP, setEditColumnInfoMP] = useState<any>();
  const [listItemsMP, setListItemsMP] = useState<Array<any>>(items || []);
  const [isLoading, setIsLoading] = useState(loading ?? false);
  const [pages, setPages] = useState(0);
  const [page, setPage] = useState(1);
  const [showToast, setShowToastMP] = useState(false);
  const [hideTable, setHideTableMP] = useState(true);
  const [arrCambiosFormMP, setArrCambiosFormMP] = useState<Array<IConfirmacionMantenedor>>(itemsArrCambiosForm || []);
  const [isOpenPopUpGuardarCambios, setIsOpenPopUpGuardarCambiosMP] = useState<boolean>(is_test ?? false);

  const [refComboARMP, setValComboARMP] = useState<IComboboxOption | null>(null);
  const [refComboTPMP, setValComboTPMP] = useState<IComboboxOption | null>(null);
  const [selectedField, setSelectedField] = useState({} as any);
  const [pageSize, setPageSize] = useState(ROW_COUNT);
  const [isSendingData, setIsSendingData] = useState(false);
  const refTxtMotivoMP = React.createRef<HTMLTextAreaElement>();

  const columnHelperMantProgramasAnuales = createColumnHelper<IPlan>();
  const columnHelperConfirmacionCambios = createColumnHelper<IConfirmacionMantenedor>();

  const changeField = (id: string, valor: any, tipo: ITipo_Campo) => {
    let sf: any = updateSelectedField(id, valor);
    setSelectedField(sf);
  };
  const component = (titulo: string) => {
    return <RenderTitle title={titulo} />;
  };
  const componentValue = (value: any, type?: number) => {
    return <RenderValue value={value} type={type} />;
  };
  const componentLink = (value: any) => {
    return <RenderLink value={value} />;
  };

  const componentDesactivar = (value: any) => {
    let desactivar = value.row.original.ACTIVO ? "Desactivar" : "Activar";
    return (
      <button
        className="btnIcono"
        title={desactivar}
        onClick={() => {
          MySwal.fire({
            html: (
              <div>
                <h3>
                  ¿Desea {desactivar.toLowerCase()} el registro {value.row.original.TITULO}?
                </h3>
              </div>
            ),
            text: "",
            icon: "question",
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
            showCloseButton: true,
            showCancelButton: true,
          }).then(async (result) => {
            if (result.isConfirmed) {
              MySwal.fire({
                html: (
                  <div>
                    <h4>Ingrese un Motivo:</h4>
                  </div>
                ),
                input: "textarea",
                inputAttributes: {
                  autocapitalize: "off",
                },
                showCancelButton: true,
                confirmButtonText: `<i class="bi bi-eye"></i>${desactivar}`,
                cancelButtonText: "Cancelar",
                showLoaderOnConfirm: true,
                preConfirm: async (txtMotivo) => {
                  preconfirm(txtMotivo, value.row.original.ID, value.row.original.ACTIVO, value.row.original.TITULO);
                },
                allowOutsideClick: () => !Swal.isLoading(),
              }).then((result) => {
                console.log("");
              });
            }
          });
        }}>
        <i className={value.row.original.ACTIVO ? "fs-5 bi bi-eye-slash btnIconoActive" : "fs-5 bi bi-eye btnIconoInactive"} />
      </button>
    );
  };

  let columnsDef = [
    columnHelperMantProgramasAnuales.accessor((rowMP) => rowMP.TITULO, {
      id: "TITULO",
      cell: (infoMP: CellContext<IPlan, string>) => componentValue(infoMP.getValue()),
      header: () => component("Título"),
      hide: false,
      title: "Título",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `PL."TITULO"`,
    } as any),
    columnHelperMantProgramasAnuales.accessor((rowMP) => rowMP.ID, {
      id: "DESACTIVAR",
      cell: (infoMP: CellContext<IPlan, number>) => componentDesactivar(infoMP),
      header: () => component("Activar / Desactivar"),
      tipo: ITipo_Campo.text,
      className: "ps-3",
      disableSorting: true,
    } as any),
    columnHelperMantProgramasAnuales.accessor((rowMP) => rowMP.ACTIVO, {
      id: "ACTIVO",
      cell: (info: CellContext<IPlan, boolean>) => <i>{info.getValue() === true ? "Sí" : "No"}</i>,
      header: () => <span>Activo</span>,
      tipo: ITipo_Campo.check,
      title: "Activo",
    } as any),
    columnHelperMantProgramasAnuales.accessor((rowMP) => rowMP.ANIO, {
      id: "ANIO",
      cell: (infoMP: CellContext<IPlan, string>) => componentValue(infoMP.getValue()),
      header: () => component("Año"),
      title: "Año",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `PL."ANIO"`,
    } as any),
    columnHelperMantProgramasAnuales.accessor((rowMP) => rowMP.AREA_RESPONSABLE, {
      id: "AREA_RESPONSABLE_COLUMNA",
      cell: (infoMP: CellContext<IPlan, string>) => componentValue(infoMP.getValue()),
      header: () => component("Área Responsable"),
      hide: false,
      title: "Área Responsable",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `"AREA_RESPONSABLE"`,
    } as any),
    columnHelperMantProgramasAnuales.accessor((rowMP) => rowMP.TIPO_PROCESO, {
      id: "TIPO_PROCESO_COLUMNA",
      cell: (infoMP: CellContext<IPlan, string>) => componentValue(infoMP.getValue()),
      header: () => component("Tipo Proceso"),
      hide: false,
      title: "Tipo Proceso",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `"TIPO_PROCESO"`,
    } as any),
    columnHelperMantProgramasAnuales.accessor((rowMP) => rowMP.RESPONSABLE_DISPLAY || rowMP.RESPONSABLE, {
      id: "RESPONSABLE",
      cell: (infoMP: CellContext<IPlan, string>) => componentLink(infoMP.getValue()),
      header: () => component("Responsable"),
      hide: false,
      title: "Responsable",
      tipo: ITipo_Campo.user,
      onSelectColumn: (cell: any) => {
        setEditColumnInfoMP(cell);
        setIsEditColumMP(true);
        setIsSendingData(false);
      },
      sortId: `PL."RESPONSABLE_DISPLAY"`,
    } as any),
    columnHelperMantProgramasAnuales.accessor((rowMP) => rowMP.AUTOR_DISPLAY || rowMP.AUTOR, {
      id: "AUTOR",
      cell: (infoMP: CellContext<IPlan, string>) => componentLink(infoMP.getValue()),
      header: () => component("Creado por"),
      hide: false,
      title: "Creado por",
      tipo: ITipo_Campo.user,
      onSelectColumn: (cell: any) => {
        setEditColumnInfoMP(cell);
        setIsEditColumMP(true);
        setIsSendingData(false);
      },
      sortId: `PL."AUTOR_DISPLAY"`,
    } as any),
  ] as any;

  const preconfirm = async (txtMotivo: string, id_registro: number, activo: boolean, titulo: string) => {
    if (!txtMotivo) {
      Swal.showValidationMessage(`Debe ingresar un motivo`);
    } else {
      await ProveedorService.desactivarRegistroProgramaAnual(token, {
        ID_REGISTRO: id_registro,
        AUTOR: currentUser?.email as string,
        AUTOR_DISPLAY: currentUser?.fullname as string,
        CAMPO: "N/A",
        EDITOR: currentUser?.email as string,
        EDITOR_DISPLAY: currentUser?.fullname as string,
        MODULO: "PROVEEDORES-PROGR.ANUALES",
        TABLA: "PLAN",
        MOTIVO: txtMotivo,
        VALOR_INICIAL: "N/A",
        DESACTIVAR: activo,
        FECHA_CREACION: new Date(),
        FECHA_MODIFICACION: new Date(),
        VALOR_FINAL: "N/A",
        ACCION: activo ? "DESACTIVAR" : "ACTIVAR",
        CORRELATIVO: titulo,
      });
      await handleBuscarMP();
    }
  };

  usePromiseEffect(async () => {
    setIsLoading(true);
    let token = await userInfo;
    setToken(token);
    let currUser = await cognitoUserInfo();
    setCurrentUser(currUser);

    const comboARMP = is_test
      ? cbAreaResponsable
      : (await getAPI(`${URL_SUPPORT}${API_ADMIN_AREA_RESPONSABLE}/getall`, { Authorization: `Bearer ${token}` }, paramsActive)).result.data;
    setComboARMP(comboARMP);
  }, []);

  const getAllTipoProceso = async (e: any) => {
    let newParamsActive = { ...paramsActive, AREA_RESPONSABLE: e.value };
    const comboTPMP = is_test
      ? cbTipoRpoceso
      : (await getAPI(`${URL_SUPPORT}${API_ADMIN_TIPO_PROCESO}/getall`, { Authorization: `Bearer ${token}` }, newParamsActive)).result.data;
    setComboTPMP(comboTPMP);
  };

  const exportFileMP = () => {
    let params = {
      PAGINA: 1,
      PAGINADO: ROW_COUNT,
      ORDENADOPOR: "ID",
      ORIENTACION: "DESC",
      AREA_RESPONSABLE: refComboARMP?.value,
      TIPO_PROCESO: refComboTPMP?.value,
    };
    getAPI(`${URL_SUPPORT}${API_ADMIN_MANTENEDOR_PROGRAMAS_ANUALES}/ExportMantenedorPrograma`, { Authorization: `Bearer ${token}` }, params).then(
      (r) => {
        downloadFile(r.result);
      }
    );
  };
  const pagingMP = (page: any) => {
    setPage(page);
    filterMP({ PAGINA: page }, true);
  };

  const filterMP = (filterMP: any, page: boolean = false, size = pageSize) => {
    filterMP = updateFilter(filterMP, size, page);
    setPage(filterMP.PAGINA);
    filterMP.AREA_RESPONSABLE = refComboARMP?.value;
    filterMP.TIPO_PROCESO = refComboTPMP?.value;

    getAPI(`${URL_SUPPORT}${API_ADMIN_MANTENEDOR_PROGRAMAS_ANUALES}/GetAllMantenedorPrograma`, { Authorization: `Bearer ${token}` }, filterMP)
      .then((result) => {
        setIsLoading(false);
        setListItemsMP(result.result.data);
        let pages = result.result.pages;
        setPages(pages);
      })
      .catch((error) => {});
  };

  const editMP = (value: any, filters: any) => {
    delete value.FECHA_CREACION;
    delete value.TRANSACTION_ID;
    value.AUTOR = "";
    value.AUTOR_DISPLAY = "";
    value.EDITOR = "";
    value.EDITOR_DISPLAY = "";

    if (value.ID === "") {
      delete value.ID;
    }
  };

  const handleBuscarMP = async () => {
    setIsLoading(true);
    let params = {
      PAGINA: 1,
      PAGINADO: ROW_COUNT,
      ORDENADOPOR: `PL."ID"`,
      ORIENTACION: "DESC",
      AREA_RESPONSABLE: refComboARMP?.value === "Seleccione" ? "" : refComboARMP?.value,
      TIPO_PROCESO: refComboTPMP?.value === "Seleccione" ? "" : refComboTPMP?.value,
    };
    const result = is_test
      ? { data: items, pages: 10 }
      : (
          await getAPI(
            `${URL_SUPPORT}${API_ADMIN_MANTENEDOR_PROGRAMAS_ANUALES}/GetAllMantenedorPrograma`,
            { Authorization: `Bearer ${token}` },
            params
          )
        ).result;
    setArrCambiosFormMP([]);
    let list = result.data;
    setListItemsMP(list);
    let pages = result.pages;
    setPages(pages);
    setHideTableMP(false);
    setIsLoading(false);
  };

  const confirmd = () => {
    let arrProgrAnuales: Array<IPlan> = [];
    let arrLogs: Array<ILogMantenedor> = [];
    let cambios = is_test ? itemsArrCambiosForm ?? [] : arrCambiosFormMP;
    cambios.forEach((ac) => {
      if (!arrProgrAnuales.find((d) => d.ID === ac.ID)) {
        arrProgrAnuales.push(ac.OBJETO_REF);
      }
    });

    arrProgrAnuales.forEach((d: any) => {
      cambios
        .filter((ac) => ac.ID === d.ID)
        .forEach((ac) => {
          let log: ILogMantenedor = {
            ID: null,
            MODULO: "PROVEEDORES-PROGR.ANUALES",
            TABLA: "PLAN",
            ID_REGISTRO: d.ID,
            CAMPO: ac.CAMPO_EDITADO_ID,
            VALOR_INICIAL: ac.VALOR_ORIGINAL,
            VALOR_FINAL: null,
            MOTIVO: refTxtMotivoMP.current?.value || "",
            AUTOR: currentUser?.email || "",
            FECHA_CREACION: new Date(),
            EDITOR: "",
            FECHA_MODIFICACION: new Date(),
            AUTOR_DISPLAY: currentUser?.fullname || "",
            EDITOR_DISPLAY: "",
            CORRELATIVO: d.TITULO,
          };

          if (ac.TIPO === ITipo_Campo.user) {
            d[ac.CAMPO_EDITADO_ID] = ac.VALOR_NUEVO[ac.CAMPO_EDITADO_ID];
            d[ac.CAMPO_EDITADO_ID + "_DISPLAY"] = ac.VALOR_NUEVO[ac.CAMPO_EDITADO_ID + "_DISPLAY"];
            log.VALOR_FINAL = ac.VALOR_NUEVO[ac.CAMPO_EDITADO_ID + "_DISPLAY"];
          } else if (ac.TIPO === ITipo_Campo.date) {
            d[ac.CAMPO_EDITADO_ID] = moment(moment(ac.VALOR_NUEVO).format(moment.HTML5_FMT.DATE)).toDate();
            log.VALOR_FINAL = ac.VALOR_NUEVO;
          } else {
            d[ac.CAMPO_EDITADO_ID] = ac.VALOR_NUEVO;
            log.VALOR_FINAL = ac.VALOR_NUEVO;
          }
          arrLogs.push(log);
        });
    });

    let value = {
      LOG_MANTENEDOR: arrLogs,
      PROGRAMA: arrProgrAnuales,
    };

    postAPI(`${URL_SUPPORT}${API_ADMIN_MANTENEDOR_PROGRAMAS_ANUALES}/MantenedorPrograma`, value, {
      Authorization: `Bearer ${token}`,
    })
      .then((result) => {
        let data = result.result.data;
        console.log(data);
        if (refTxtMotivoMP.current) {
          refTxtMotivoMP.current.value = "";
        }
        setArrCambiosFormMP([]);
        setIsOpenPopUpGuardarCambiosMP(false);
        setShowToastMP(true);
        let params = { PAGINA: page };
        filterMP(params);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <section>
      <div className="row">
        <button
          data-testid="btnedit"
          hidden={true}
          onClick={() => {
            handleBuscarMP();
            exportFileMP();
            filterMP({});
            editMP({ ID: "" }, {});
            pagingMP(1);
            preconfirm("", 1, true, "");
            preconfirm("2", 1, true, "");
            confirmd();
            getAllTipoProceso("");
          }}></button>
        <div className="col-12">
          <div className="rounded bg-white p-2 shadow">
            <div className="container-fluid mb-2">
              <h1 className="titPrincipal colorTit mt-2">Mantenedor Proveedores - Programas Anuales</h1>
              <div className="alert alert-warning p-1 mb-2" role="alert">
                <i className="text-info bi bi-info-circle-fill me-2"></i>
                <small>
                  <strong>Importante:</strong> Este módulo es de uso exclusivo de administración y su uso esta bajo su responsabilidad
                </small>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="6">
                  <label>Área Responsable:</label>
                  <Select
                    placeholder="Seleccione"
                    value={refComboARMP || ""}
                    isClearable={true}
                    noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
                    options={comboARMP.map((vcc) => ({ value: vcc.TITULO, label: vcc.TITULO }))}
                    onChange={async (e: any) => {
                      setValComboARMP(e);
                      getAllTipoProceso(e);
                    }}
                  />
                </Col>
                <Col xs="12" md="6" lg="6">
                  <label>Tipo Proceso:</label>
                  <Select
                    placeholder="Seleccione"
                    value={refComboTPMP || ""}
                    isClearable={true}
                    noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
                    options={comboTPMP.map((vcc) => ({ value: vcc.TITULO, label: vcc.TITULO }))}
                    onChange={async (e: any) => {
                      setValComboTPMP(e);
                    }}
                  />
                </Col>
              </div>
              <div className="row mb-2 mt-2">
                <Col xs="12" md="12" lg="12">
                  <button
                    className="btn btn-primary btn-sm me-2"
                    onClick={() => {
                      handleBuscarMP();
                    }}>
                    {" "}
                    <i className="bi bi-search"></i> Buscar
                  </button>
                  <button
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={() => {
                      setValComboARMP(null);
                      setValComboTPMP(null);
                      setArrCambiosFormMP([]);
                      setListItemsMP([]);
                    }}>
                    {" "}
                    <i className="bi bi-stars"></i> Limpiar Campos
                  </button>

                  {arrCambiosFormMP.length > 0 && (
                    <button
                      className="btn btn-primary btn-sm me-2 float-end"
                      onClick={() => {
                        setIsOpenPopUpGuardarCambiosMP(true);
                      }}>
                      {" "}
                      <i className="bi bi-check"></i> Guardar Cambios
                    </button>
                  )}
                </Col>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row mb-1">
        <AdminLista
          reload={filterMP}
          items={[]}
          callback={editMP}
          data={listItemsMP}
          tipo={"MantenedorDesviaciones"}
          filter={filterMP}
          pagination={{ pages: pages, page: page, paging: pagingMP }}
          title=""
          hideAdd={true}
          hideExport={true}
          exportar={exportFileMP}
          columnsDef={columnsDef}
          hideTable={hideTable}
          callbackUpdatePageSize={(pageSize: number, filters: Object) => {
            setPageSize(pageSize);
            filterMP(filters, false, pageSize);
          }}
          isLoading={isLoading}
        />
      </div>

      {editColumnInfoMP && (
        <Offcanvas
          show={isEditColumMP}
          onHide={() => {
            setIsEditColumMP(false);
          }}
          placement={"end"}>
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Editar - {editColumnInfoMP.column.columnDef.title}</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="row mb-2">
              <div className="ajusteInput">
                <label>Valor Original</label>
              </div>
              <div>{editColumnInfoMP && editColumnInfoMP?.getValue()}</div>
            </div>
            <div className="row mb-2 ajusteInput">
              <div>
                <label>Nuevo Valor</label>
                <form className="form-control-sm">
                  {
                    <RenderForm
                      id={editColumnInfoMP?.column?.id}
                      tipoCampo={editColumnInfoMP?.column.columnDef.tipo}
                      valor={""}
                      texto={""}
                      callback={changeField}
                    />
                  }
                </form>
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-12">
                <button
                  className="btn btn-primary btn-sm me-2"
                  onClick={() => {
                    let json = selectedField;
                    let arr = arrCambiosFormMP;
                    json = {
                      ID: editColumnInfoMP.row.original.ID,
                      CAMPO_EDITADO: editColumnInfoMP.column.columnDef.title,
                      CAMPO_EDITADO_ID: editColumnInfoMP.column.columnDef.id,
                      VALOR_ORIGINAL: editColumnInfoMP?.getValue(),
                      VALOR_NUEVO:
                        editColumnInfoMP.column.columnDef.tipo === ITipo_Campo.user
                          ? selectedField
                          : selectedField[editColumnInfoMP.column.columnDef.id],
                      OBJETO_REF: editColumnInfoMP.row.original,
                      TIPO: editColumnInfoMP.column.columnDef.tipo,
                    };
                    if (
                      !isSendingData &&
                      json.VALOR_ORIGINAL !==
                        (editColumnInfoMP.column.columnDef.tipo === ITipo_Campo.user
                          ? json.VALOR_NUEVO[json.VALOR_NUEVO.ID + "_DISPLAY"]
                          : json.VALOR_NUEVO)
                    ) {
                      arr.push(json);
                      setArrCambiosFormMP(arr);
                      setIsEditColumMP(false);
                      setIsSendingData(true);
                    }
                  }}>
                  {" "}
                  <i className="bi bi-check"></i> Aceptar
                </button>

                <button
                  className="btn btn-outline-secondary btn-sm me-2"
                  onClick={() => {
                    setIsEditColumMP(false);
                  }}>
                  {" "}
                  <i className="bi bi-x"></i> Cancelar
                </button>
              </div>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      )}
      {isOpenPopUpGuardarCambios && (
        <Offcanvas
          show={isOpenPopUpGuardarCambios}
          onHide={() => {
            setIsOpenPopUpGuardarCambiosMP(false);
          }}
          placement={"end"}
          className={"w-50"}>
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Confirmar Cambios</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="row mb-2">
              <span>Se realizarán los siguientes cambios en los siguientes registros de Desviaciones:</span>
            </div>
            <div className="row mb-2">
              <AdminLista
                reload={filterMP}
                items={[]}
                callback={editMP}
                data={arrCambiosFormMP}
                tipo={"MantenedorProgramasAnuales"}
                filter={filterMP}
                pagination={{ pages: pages, page: page, paging: pagingMP }}
                title=""
                hideAdd={true}
                hideExport={true}
                hideReload={true}
                hidePagination={true}
                columnsDef={[
                  columnHelperConfirmacionCambios.accessor((rowMP) => rowMP.ID, {
                    id: "ID",
                    cell: (infoMP: CellContext<IConfirmacionMantenedor, string>) => componentValue(infoMP.getValue()),
                    header: () => component("ID Registro"),
                    tipo: ITipo_Campo.text,
                  } as any),
                  columnHelperConfirmacionCambios.accessor((rowMP) => rowMP.CAMPO_EDITADO, {
                    id: "CAMPO_EDITADO",
                    cell: (infoMP: CellContext<IConfirmacionMantenedor, string>) => componentValue(infoMP.getValue()),
                    header: () => component("Campo Editado"),
                    tipo: ITipo_Campo.text,
                  } as any),
                  columnHelperConfirmacionCambios.accessor((rowMP) => rowMP.VALOR_ORIGINAL, {
                    id: "VALOR_ORIGINAL",
                    cell: (infoMP: CellContext<IConfirmacionMantenedor, string>) => componentValue(infoMP.getValue()),
                    header: () => component("Valor Original"),
                    tipo: ITipo_Campo.text,
                  } as any),
                  columnHelperConfirmacionCambios.accessor((rowMP) => rowMP.VALOR_NUEVO, {
                    id: "VALOR_NUEVO",
                    cell: (infoMP: CellContext<IConfirmacionMantenedor, any>) => componentValue(infoMP.getValue(), infoMP.getValue()?.TIPO),
                    header: () => component("Nuevo Valor"),
                    tipo: ITipo_Campo.text,
                  } as any),
                ]}
              />
            </div>
            <div className="row mb-2">
              <div className="col-12">
                <label>Motivos Modificación</label>
              </div>
              <div className="col-12">
                <textarea ref={refTxtMotivoMP} className="w-100"></textarea>
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-12">
                <button
                  className="btn btn-primary btn-sm me-2"
                  onClick={() => {
                    if (!refTxtMotivoMP.current?.value) {
                      refTxtMotivoMP.current?.classList.add("error");
                      return;
                    } else {
                      refTxtMotivoMP.current?.classList.remove("error");
                    }
                    MySwal.fire({
                      html: (
                        <div>
                          <h3>¿Desea realizar los cambios con el siguiente Motivo descrito?</h3>
                          <div>(se registraran las modificaciones a su nombre y cada una asociada al motivo entregado)</div>
                        </div>
                      ),
                      text: refTxtMotivoMP.current?.value,
                      icon: "question",
                      confirmButtonText: "Aceptar",
                      cancelButtonText: "Cancelar",
                      showCloseButton: true,
                      showCancelButton: true,
                    }).then((result) => {
                      if (result.isConfirmed) {
                        confirmd();
                      }
                    });
                  }}>
                  {" "}
                  <i className="bi bi-check"></i> Aceptar
                </button>
                <button
                  className="btn btn-outline-secondary btn-sm me-2"
                  onClick={() => {
                    setIsOpenPopUpGuardarCambiosMP(false);
                  }}>
                  {" "}
                  <i className="bi bi-x"></i> Cancelar
                </button>
              </div>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      )}
      <div className="row">
        <div className="col-12">
          <CustomToast show={showToast} title="Administración" />
        </div>
      </div>
    </section>
  );
}
